export function capetalize(str) {   
    const removeHyphen = str.replace(/-/g, ' ');
    const splitToArray = removeHyphen.split(' ');
    
    return splitToArray.map(res => {
        return res.charAt(0).toUpperCase() + res.slice(1);
}).join(' '); 
};


export function cutAddress(str) {
    const addressRaw = str.split(',')
    return addressRaw.slice(-addressRaw.length, -3)
}
 